module.exports = __webpack_public_path__ + "static/media/NE (1).3ec915c9.svg";